import RegionModel from 'Models/RegionModel';

const WowClassic20thModel = {};

// Не забудь обновить бэк.
// @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_WOW_BC -> RegionMap::REGION_ID_EU
WowClassic20thModel[RegionModel.EU.id] = [
  {
    id: 1,
    title: '[Hardcore] Soulseeker',
  },
  {
    id: 2,
    title: '[Normal] Thunderstrike',
  },
  {
    id: 3,
    title: '[PVP] Spineshatter',
  },
];

// Не забудь обновить бэк.
// @see \App\Types\Maps\ServerMap -> ProductGameEnum::GAME_WOW_BC -> RegionMap::REGION_ID_USA
WowClassic20thModel[RegionModel.USA.id] = [
  {
    id: 1,
    title: '[AU PVP] Maladath',
  },
  {
    id: 2,
    title: '[Hardcore] Doomhowl',
  },
  {
    id: 3,
    title: '[Normal] Dreamscythe',
  },
  {
    id: 4,
    title: '[PVP] Nightslayer',
  },
];

// eslint-disable-next-line import/prefer-default-export
export { WowClassic20thModel };
